export const paths = [
	"M6.95017 8.19765C17.2058 -2.99805 33.6242 4.33116 47.5944 4.64098C59.4603 4.90413 71.9293 2.79464 81.026 9.84042C91.1166 17.656 97.371 29.9185 97.9336 43.6309C98.542 58.4598 95.0477 74.8387 84.1413 85.7687C73.505 96.428 58.2977 96.6126 44.3219 97.3589C30.7609 98.083 15.181 100.035 6.7788 89.8996C-1.3716 80.068 5.49946 64.2539 5.52818 50.5633C5.55888 35.9261 -3.3047 19.3926 6.95017 8.19765Z"
	"M37.1071 93.4379C22.0739 77.4689 -6.11936 67.1235 4.23023 32.2667C14.5654 -2.5414 37.3932 2.06224 56.2355 2.35359C71.9159 2.59605 95.9271 5.12767 97.8883 33.7149C99.859 62.4409 75.3031 75.878 59.7098 91.1998C51.5735 99.1945 43.6573 100.396 37.1071 93.4379Z"
	"M9.29261 5.23311C21.8211 -4.9955 35.5207 12.0092 49.7636 15.442C60.6519 18.0663 73.5169 14.3472 80.9487 22.5036C91.3853 33.9578 103.182 50.0749 95.5757 65.7208C88.0075 81.288 67.0064 78.5017 51.1777 83.7402C35.8226 88.8219 18.4865 104.422 6.87518 95.0759C-4.6975 85.7611 7.90853 65.3205 8.34065 49.2608C8.75633 33.8123 -3.15401 15.3948 9.29261 5.23311Z"
	"M44.9691 4.79871C56.6118 5.67153 68.507 5.369 77.777 12.665C88.3572 20.9924 96.7262 32.7477 97.8277 46.4017C99.009 61.0447 94.0942 76.1464 83.7126 86.2421C73.5557 96.1193 58.9147 98.8044 44.9691 97.8045C32.0316 96.8769 19.396 91.4475 11.2764 81.0484C3.83447 71.517 5.54215 58.6033 4.83431 46.4017C4.04958 32.8746 -2.27931 16.9796 7.00157 7.35917C16.2873 -2.26621 31.8192 3.81289 44.9691 4.79871Z"
	"M46.6443 2.02753C66.6399 1.53324 88.5794 7.59278 95.422 28.5087C102.874 51.2865 93.5364 76.7516 75.5776 90.4677C58.9651 103.156 37.2191 98.7293 21.1053 85.2685C5.82684 72.5056 -2.06419 50.8861 4.10887 30.7659C10.0345 11.4522 28.3111 2.48073 46.6443 2.02753Z"
	"M13.4722 14.9548C27.7804 -2.67845 49.7337 0.345336 67.4 8.41128C84.5927 16.261 100.585 31.1761 97.6499 53.388C94.6973 75.7326 75.1119 89.9688 55.8613 95.735C37.5404 101.223 18.5249 97.0492 9.47335 79.7998C-0.70101 60.4107 -1.5127 33.4221 13.4722 14.9548Z"
	"M48.3671 4.00414C61.7855 2.7251 76.745 -1.97133 86.4625 9.80638C97.2181 22.8423 100.354 43.9553 96.2873 62.0843C92.4299 79.2819 80.463 91.9101 66.9118 96.9691C55.504 101.228 45.1731 91.3023 34.2907 85.2291C22.5778 78.6925 6.96447 76.7547 3.05352 61.3315C-1.02481 45.2483 7.40784 28.3849 16.8479 16.442C25.0359 6.08323 36.8209 5.10471 48.3671 4.00414Z"
	"M87.5194 12.6911C100.724 30.4477 100.024 56.2045 93.265 75.1548C86.9776 92.7838 73.2551 101.066 57.4621 96.9686C35.4989 91.2701 7.03718 81.4582 2.47942 51.5996C-1.94928 22.5864 25.2781 17.5186 44.0252 8.94122C58.235 2.43979 74.9374 -4.22816 87.5194 12.6911Z"
]

export const colors = [
	"coral"
	"lilac"
	"mint"
	"tiger"
	"baby"
	"lemon"
	"gray"
]

global css .shape
	c:currentColor
	path fill:var(--c,currentColor)


global css .pattern
	bgc:$c
	fs:$tilefs
	lh:1.05
	$tc:hsl(213deg 31% 37%)
	$hs:1
	$rot:0deg
	$scale:1

	.heading
		pos:absolute inset:3 d:flex ja:center ws:initial fw:700 ta:right
		ts:0px 2px 0px white/70 zi:10 c:$tc
	
	.shapes pos:absolute inset:0

	&.live
		.shapes tween:styles 0.2s quart-out transform:rotate($rot) scale($scale)
		svg tween:styles 0.2s quart-out

def svg-style {w,l,t,o,rot,ar,c}
	let trx = "translate3d(-50%,-50%,{w}px) rotate({rot}deg) scale(var(--hs)) scaleY({ar})"
	"width:{w}%;left:{l}%;top:{t}%;transform:{trx};opacity:{o};--o:{o};--c:{c ? "var(--{c})" : 'currentColor'}"

tag art-pattern
	heading

	set data data
		$d = data
		construct!
	
	def construct
		<self[d:block of:hidden $c:{"var(--{$d.c})"}].pattern.live>
			<span.heading> heading or ''
			<.shapes> for shape in $d.shapes
				<svg.shape style=svg-style(shape) width=100 viewBox="0 0 100 100" preserveAspectRatio="none" height=100>
					<path d=paths[shape.type]>
			
				
# <svg[w:{shape.w}% l:{shape.l}% t:{shape.t}% scale-y:{shape.ar} x:-50% y:-50% rotate:{shape.rot}deg].shape .{shape.f} width=100 viewBox="0 0 100 100" preserveAspectRatio="none" height=100>
# <path[fill:currentColor fill-opacity:{shape.o}] d=paths[shape.type]>